<template>
  <div>
    <div class="box mb20">
      <el-page-header
        @back="$router.go(-1)"
      ></el-page-header>
    </div>
    <el-card class="mb15" shadow="hover">
      <el-row>
        <el-input
          :placeholder="$t('search')"
          clearable
          v-model="filter.search"
          @keyup.enter.native="get_list"
        ></el-input>
      </el-row>
      <el-row class="mt20 flexBC" type="flex" align="middle">
        <div>
          <el-button @click="get_list" type="primary" class="search">{{
            $t("search_zh")
          }}</el-button>
          <el-button @click="reset" type="info">{{
            $t("btnTip.reset")
          }}</el-button>
        </div>
        <div>
          <el-button @click="toPage('toTask')" type="success">{{
            $t("readList.toTask")
          }}</el-button>
          <el-button @click="toPage('toNotice')" type="success">{{
            $t("readList.toNotice")
          }}</el-button>
          <el-button @click="toPage('toComment')" type="success">{{
            $t("readList.toComment")
          }}</el-button>
        </div>
      </el-row>
    </el-card>
    <el-card shadow="hover">
      <div class="flexBC mb20">
        <div></div>
        <el-button type="primary" @click="outExe">{{ $t("outExe") }}</el-button>
      </div>
      <my-table
        tree="reply_list"
        :columns="columns"
        :data="list_data.list"
        :showIndex="false"
        :showSelection="false"
        :cellStyle="{ padding: '6px 0' }"
        :headerCellStyle="{
          background: 'rgba(51, 55, 68, 1)',
          color: '#fff',
        }"
        @emitSelection="allSelect"
        @sortChange="sort_change"
      >
       <template v-slot:from_user__create_time="slotProps">
          <div>{{slotProps.callback.row.create_time}}</div>
        </template>
      <template v-slot:from_user__real_name="slotProps">
          <div>{{slotProps.callback.row.from_user.real_name}}</div>
        </template>
        <template v-slot:from_user__avatar="slotProps">
          <div>
              <img style="border-radius:50%;width:30px;height:30px;object-fit:cover" :src="slotProps.callback.row.from_user.avatar" alt />
          </div>
        </template>
         <template v-slot:content="slotProps">
          <div v-html="slotProps.callback.row.content"></div>
        </template>
        <template v-slot:is_top="slotProps">
          <el-tag v-if="slotProps.callback.row.is_top === 0 || slotProps.callback.row.is_top === 1" :type="is_topTag(slotProps.callback.row.is_top)">{{is_top(slotProps.callback.row.is_top)}}</el-tag>
        </template>
        <!-- <template v-slot:delete="slotProps">
          <el-tag :type="activeTag(slotProps.callback.row.delete)">
            {{
              active(slotProps.callback.row.delete)
            }}
          </el-tag>
        </template> -->
        <template v-slot:operation="slotProps">
          <el-tooltip
           v-if="slotProps.callback.row.is_top === 0 || slotProps.callback.row.is_top === 1"
            class="item"
            effect="dark"
            :content="
              slotProps.callback.row.is_top === 0
                ? $t('readTopicList').top1
                : $t('readTopicList').top0
            "
            placement="top"
          >
            <el-button
              @click="handleClick('is_top', slotProps.callback.row)"
              :type="
                slotProps.callback.row.is_top === 0 ? 'success' : 'warning'
              "
              size="mini"
              >{{
                slotProps.callback.row.is_top === 0
                  ? $t("readTopicList").top1
                  : $t("readTopicList").top0
              }}</el-button
            >
          </el-tooltip>
          <el-tooltip
            v-if="slotProps.callback.row.delete===0"
            class="item"
            effect="dark"
            :content="$t('btnTip').delete"
            placement="top"
          >
            <el-button
              size="mini"
              type="danger"
              @click="del(slotProps.callback.row.id)"
              >{{ $t("btnTip").delete }}</el-button
            >
          </el-tooltip>
        </template>
      </my-table>
      <page
        :total="list_data.total"
        :page_size.sync="pageSize"
        :page.sync="page"
      />
    </el-card>
  </div>
</template>
<script>
import { mixin_list } from "@/mixins";
import page from "@/components/page";
import myTable from "@/components/table";
import { readTopicList, deleteReadTopic, setReadTopicTop } from "@/api/api";
export default {
  name: "readTopicList",
  mixins: [mixin_list(readTopicList)],
  components: {
    myTable,
    page,
  },
  data() {
    return {
      filter: {
        search: "",
        club:this.$route.params.readId
      },
      columns: [
        {
          label: "ID",
          sortable: true,
          prop: "id",
          width: 100,
        },
        {
          label: this.$t("readTopicList.create_time"),
          sortable: true,
          slot:"from_user__create_time",
          prop: "from_user__create_time",
        },
        {
          label: this.$t("readTopicList.real_name"),
          sortable: true,
          prop: "from_user__real_name",
          slot:"from_user__real_name"
        },
        {
          label: this.$t("readTopicList.avatar"),
          prop: "from_user__avatar",
          slot:"from_user__avatar",
          width:120
        },
        {
          label: this.$t("readTopicList.content"),
          prop: "content",
          slot: "content"
        },
        {
          label: this.$t("readTopicList.is_top"),
          prop: "is_top",
          slot:"is_top",
          width:120
        },
        // {
        //   label: this.$t("readTopicList.delete"),
        //   sortable: true,
        //   prop: "delete",
        //   slot:"delete"
        // },
        {
          label: this.$t("operation"),
          prop: "",
          width: 200,
          slot: "operation",
        },
      ]
    }
  },
  methods: {
    toPage(toPage){
      switch(toPage){
        case 'toTask':
          this.$router.replace(`/readManagement/readList/${this.$route.params.readId}/readTaskList`)
          return
        case 'toTopic':
          this.$router.replace(`/readManagement/readList/${this.$route.params.readId}/readTopicList`)
          return
        case 'toNotice':
          this.$router.replace(`/readManagement/readList/${this.$route.params.readId}/readNoticeList`)
          return
        case 'toComment':
          this.$router.replace(`/readManagement/readList/${this.$route.params.readId}/readCommentList`)
          return
      }
    },
    is_top(is_top){
      switch(is_top){
        case 0:
          return this.$t('readTopicList.is_top0')
        case 1:
          return this.$t('readTopicList.is_top1')
      }
    },
    is_topTag(is_top){
      switch(is_top){
        case 1:
          return 'success'
        case 0:
          return 'info'
      }
    },
    async handleClick(type, data) {
      switch (type) {
        case "is_top":
          await setReadTopicTop({
            id: data.id,
            is_top: data.is_top === 0 ? 1 : 0,
          });
          this.get_list();
          break;
      }
    },
    async del(id) {
      this.$confirm(this.$t('readTopicList').sureDeleteTopic, this.$t('tips'), {
        confirmButtonText: this.$t('btnTips').submit,
        cancelButtonText: this.$t('btnTips').cancel,
        type: 'warning'
      }).then(async () => {
        let res = await deleteReadTopic({id})
        this.get_list()
      }).catch({
      })
    },
  },
};
</script>
<style lang="scss" scoped>
.text{
  width:100px;
  font-size: 16px;
}
</style>